var map = {
	"./de-DE": 261,
	"./de-DE.es": 260,
	"./de-DE.es.js": 260,
	"./de-DE.js": 261,
	"./en-GB": 263,
	"./en-GB.es": 262,
	"./en-GB.es.js": 262,
	"./en-GB.js": 263,
	"./fr-FR": 265,
	"./fr-FR.es": 264,
	"./fr-FR.es.js": 264,
	"./fr-FR.js": 265,
	"./it-IT": 267,
	"./it-IT.es": 266,
	"./it-IT.es.js": 266,
	"./it-IT.js": 267,
	"./whitelist_de-DE": 268,
	"./whitelist_de-DE.js": 268,
	"./whitelist_en-GB": 269,
	"./whitelist_en-GB.js": 269,
	"./whitelist_fr-FR": 270,
	"./whitelist_fr-FR.js": 270,
	"./whitelist_it-IT": 271,
	"./whitelist_it-IT.js": 271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 880;
module.exports = webpackContext;